<template>
  <div class="card-container">
    <card class="card-login card-white">
      <Header pageTitle="Login"></Header>

      <label for="Email">Email:</label>
      <base-input
        id="Email"
        v-validate="userValidations.email"
        name="email"
        :error="getError('email')"
        v-model.trim="user.email"
        placeholder="Email"
        addon-left-icon="tim-icons icon-email-85"
      ></base-input>
      <label for="Password">Password:</label>
      <base-input id="Password" v-on:keyup.enter="login(user)"
        v-validate="userValidations.password"
        name="password"
        :error="getError('password')"
        v-model="user.password"
        type="password"
        placeholder="Password"
        addon-left-icon="tim-icons icon-lock-circle"
      ></base-input>

      <router-link
        to="/Account/ForgotPassword"
        class="float-right smaller-font"
        type="secondary"
        v-b-popover.hover.right="
          'Send a password reset email. You will be prompted for your email address.'
        "
        >Forgot Password?</router-link
      >
      <br />
      <base-button
        @click="login(user)"
        type="primary"
        :disabled="duringSubmit || isLoading"
        class="float-right"
        v-b-popover.hover.right="
          'Login to AGATRS using your username and password.'
        "
      >
        <i class="tim-icons icon-single-02"></i> Login
      </base-button>
      <base-button
        @click="loginCac"
        type="primary"
        :disabled="duringSubmit"
        v-b-popover.hover.left="'Login to AGATRS using your CAC.'"
      >
        <i class="tim-icons icon-badge"></i> CAC Login
      </base-button>
      <hr />
      <router-link
        to="/Register"
        class="btn col-md-12"
        type="primary"
        v-b-popover.hover.top="
          'Fill out a form in order to register for AGATRS.'
        "
      >
        <i class="tim-icons icon-paper"></i> Register
      </router-link>
    </card>
  </div>
</template>

<script>
import VeeValidate from "vee-validate";
import Header from "@/components/App/Header";
import { mapGetters, mapActions } from "vuex";
import Loading from 'src/components/LoadingPanel';

export default {
  name: "Login",
  components: {
    VeeValidate,
    Header,
    Loading
  },
  async mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    this.$loaderApp.addRequest();
    var isFromLogout = this.$route.params.fromLogout;
    if(isFromLogout) {
      // Use the new clearAllLogoutData action for consistency
      await this.clearAllLogoutData();
      // localStorage.removeItem("vuex"); // Generally not needed if Vuex store is properly reset
    }
    this.$loaderApp.completeRequest();
    this.isLoading = false
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  data() {
    return {
      isLoading: false,
      user: {
        email: "",
        password: "",
      },
      error: null,
      userValidations: {
        email: {
          required: true,
          email: true,
        },
        password: {
          required: true,
          min: 15,
        },
      },
      duringSubmit: false
    };
  },

  computed: {
    ...mapGetters("authentication", [
      "isLoggedIn",
    ]),
  },
  methods: {
    ...mapActions("authentication", [
      "cac_login",
      "login", 
      "clearAllLogoutData" 
    ]),
    handleBeforeUnload(event) {
      this.isLoading = true
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then((isValid) => {
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },

    async login() { 
      this.duringSubmit = true;
      try {
        await this.$store.dispatch("authentication/login", this.user); 
      } catch(err) {
        this.error = err.response?.data?.errors || err.response?.data?.message || "Login failed";
        console.error("Login component error:", err);
      } finally {
        this.duringSubmit = false;
      }
    },
    async loginCac() {
      this.duringSubmit = true;
      try{
        await this.$store.dispatch("authentication/cac_login"); 
      } catch(err) {
        this.error = err.response?.data?.errors || err.response?.data?.message || "CAC login failed";
        console.error("CAC Login component error:", err);
      } finally {
        this.duringSubmit = false;
      }
    },
  },
};
</script>
<style></style>